<script>
import ConfirmModal from "./Applicant/ConfirmModal.vue";
    export default {
      components: {
        ConfirmModal
      },
      props: {
        id: String,
        csrfToken: String,
        type: {
          type: String,
          default: 'requisition'
        }
      },
      data () {
        return {
          requisitionId: this.id,
          csrfToken: this.csrfToken,
          type: this.type
        }
      },
      methods: {
        toggleModal() {
          this.$refs.confirmModal.toggleModal()
        },
      }
    }
</script>

<template>
  <div>
    <a id="show-modal" @click="toggleModal()" class="button success">
      Request Ad Creation
    </a>

    <confirm-modal ref="confirmModal" :requisition-id="requisitionId" :csrf-token="csrfToken" :type="type"/>
  </div>
</template>
